import { createRouter, RouterProvider } from '@tanstack/react-router';
import { useAuth } from 'react-oidc-context';

import { queryClient } from '@/app/lib/tanstack-query';
import { PageLoader } from '@/common/components/page-loader';

import { routeTree } from './routeTree.gen';

const router = createRouter({
  routeTree,
  context: {
    queryClient,
    auth: undefined!
  },
  defaultPendingComponent: PageLoader,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export function AppRouter() {
  const auth = useAuth();

  if (auth.isLoading) return <></>; // give the auth route params a chance to process

  return <RouterProvider router={router} context={{ auth }} />;
}
